export default __webpack_public_path__ + "static/university-of-british-columbia-ad222568e8e26d842d1037754a4dc17a.png";